var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.163 78.469h5.062v-20.25h20.25v-5.063H46.163V78.47zM36.038 27.844V2.53h-5.063v20.25h-20.25v5.063h25.313zM13.05 68.75l-.203-.2a15.896 15.896 0 010-22.481l11.897-11.897h-7.16l-8.317 8.317a20.959 20.959 0 000 29.639l.203.202a20.982 20.982 0 0029.64 0l.722-.723v-7.16l-4.303 4.304a15.914 15.914 0 01-22.48 0zM72.93 8.872l-.202-.203C64.557.497 51.26.498 43.088 8.67l-.722.724v7.16l4.303-4.304a15.914 15.914 0 0122.48 0l.202.202a15.897 15.897 0 010 22.48L57.454 46.83h7.16l8.317-8.318a20.958 20.958 0 000-29.64z",
    fill: "#ebFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBroken);
export default __webpack_public_path__ + "static/media/Link-Broken.07f9a695c88d4bcb8b90ff5a316643f5.svg";
export { ForwardRef as ReactComponent };